// extracted by mini-css-extract-plugin
export var divider = "_co-7";
export var itemsToggle = "_co-8";
export var mergeModal = "_co-1";
export var optionCard = "_co-4";
export var radioGroup = "_co-6";
export var radioOption = "_co-0";
export var selected = "_co-5";
export var shipmentOptions = "_co-2";
export var tableOptions = "_co-3";